(function () {
  // Expand an answer. When animating, release to `none` after the transition so
  // late layout changes (e.g. webfonts loading) can never clip the bottom text.
  function expandAnswer(answer, animate) {
    if (!answer) return;
    if (!animate) {
      answer.style.maxHeight = 'none';
      return;
    }
    answer.style.maxHeight = answer.scrollHeight + 'px';
    var release = function (event) {
      if (event && event.propertyName && event.propertyName !== 'max-height') return;
      answer.style.maxHeight = 'none';
      answer.removeEventListener('transitionend', release);
    };
    answer.addEventListener('transitionend', release);
  }

  function collapseAnswer(answer) {
    if (!answer) return;
    if (answer.style.maxHeight === 'none') {
      answer.style.maxHeight = answer.scrollHeight + 'px';
      void answer.offsetHeight; // force reflow so the collapse can transition
    }
    answer.style.maxHeight = null;
  }

  function initFaq(root) {
    if (!root || root.dataset.bunkyLfFaqReady === 'true') return;
    root.dataset.bunkyLfFaqReady = 'true';

    var buttons = root.querySelectorAll('[data-bunky-lf-faq-btn]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('[data-bunky-lf-faq-item]');
        if (!item) return;
        var answer = item.querySelector('[data-bunky-lf-faq-answer]');
        var isOpen = item.classList.contains('is-open');

        root.querySelectorAll('[data-bunky-lf-faq-item]').forEach(function (other) {
          other.classList.remove('is-open', 'active');
          var otherAnswer = other.querySelector('[data-bunky-lf-faq-answer]');
          var otherBtn = other.querySelector('[data-bunky-lf-faq-btn]');
          collapseAnswer(otherAnswer);
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen && answer) {
          item.classList.add('is-open', 'active');
          expandAnswer(answer, true);
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    var openItem = root.querySelector('[data-bunky-lf-faq-item].is-open, [data-bunky-lf-faq-item].active');
    if (openItem) {
      var openAnswer = openItem.querySelector('[data-bunky-lf-faq-answer]');
      var openBtn = openItem.querySelector('[data-bunky-lf-faq-btn]');
      expandAnswer(openAnswer, false);
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }
  }

  function initLabelModal(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-bunky-label-open]').forEach(function (btn) {
      if (btn.dataset.bunkyLabelReady === 'true') return;
      btn.dataset.bunkyLabelReady = 'true';
      var modalId = btn.getAttribute('aria-controls');
      var modal = modalId ? document.getElementById(modalId) : null;
      if (!modal) return;

      function openModal() {
        modal.hidden = false;
        document.documentElement.classList.add('bunky-label-modal-open');
        var closeBtn = modal.querySelector('[data-bunky-label-close]');
        if (closeBtn) closeBtn.focus();
      }

      function closeModal() {
        modal.hidden = true;
        document.documentElement.classList.remove('bunky-label-modal-open');
        btn.focus();
      }

      btn.addEventListener('click', openModal);
      modal.querySelectorAll('[data-bunky-label-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) closeModal();
      });
    });
  }

  function initScrollTop(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-bunky-scroll-top]').forEach(function (link) {
      if (link.dataset.bunkyScrollReady === 'true') return;
      link.dataset.bunkyScrollReady = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var target = document.getElementById('BunkyPdpMain') || document.getElementById('MainContent') || document.body;
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    });
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-bunky-lf-faq]').forEach(initFaq);
    initLabelModal(root);
    initScrollTop(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var faq = event.target.querySelector('[data-bunky-lf-faq]');
    if (faq) {
      faq.dataset.bunkyLfFaqReady = 'false';
      initFaq(faq);
    }
    boot(event.target);
  });
})();
